import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MortalityModel } from '../models/MortalityModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class MortalityService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public GetMortality(mortalitypatientCode: string , comcode: string) {
      let params = new HttpParams();
        params = params.append("mortalitypatientCode", mortalitypatientCode);
        params = params.append("compcode", comcode);
        const options = {
            params: params
        };
        return this.http.get<MortalityModel>(this.urlsconfig.WebAPIURL_Test + 'api/Mortality/GetMortality',options);
    }
    public AddMortality(doctors: MortalityModel) {
       console.log("---",MortalityModel)
        return this.http.post<MortalityModel>(this.urlsconfig.WebAPIURL_Test + 'api/Mortality/AddMortality', doctors);
    }
    public DelMortality(mortalitypatientCode: string , comcode: string) {

      let params = new HttpParams();
          params = params.append("mortalitypatientCode", mortalitypatientCode);
          params = params.append("compcode", comcode);
        const options = {
          params: params
      };
      return this.http.delete<MortalityModel>(this.urlsconfig.WebAPIURL_Test + 'api/Mortality/DeleteMortality',options);
    }


}
